import { useCallback } from "react";
import { useFormAPI } from "@/widgets/classic-form/form";
import { useRequiredNameFields } from "@/entities/form-metadata";

export const useToggleNameExactness = () => {
    const { setFieldValue } = useFormAPI();
    const requiredNameFields = useRequiredNameFields();

    return useCallback(
        (newValue: boolean) => {
            if (!newValue) {
                // A required name field is locked to Exact regardless of MAT, so turning MAT off
                // must not clear its exactness — keep it exact-only. See TT-3965.
                setFieldValue("name.givenNameExactness", {
                    isExact: requiredNameFields.givenName,
                    flags: { phonetic: false, similar: false, initials: false },
                });
                setFieldValue("name.surnameExactness", {
                    isExact: requiredNameFields.surname,
                    flags: { phonetic: false, similar: false, soundex: false },
                });
            } else {
                setFieldValue("name.givenNameExactness.isExact", newValue);
                setFieldValue("name.surnameExactness.isExact", newValue);
            }
        },
        [setFieldValue, requiredNameFields],
    );
};
